import { createSlice } from "@reduxjs/toolkit";

const initState = {
    form8data: [] ,// assuming it's an array
    allform8Data:[]
};

const formDataReducer = createSlice({
    name: "form8data",
    initialState: initState,
    reducers: {
        setForm8Data: (state, action) => {
            state.form8data = action.payload;
        },
        deleteForm8DataByIndex: (state, action) => {
            const index = action.payload;
            console.log("Deleting index:", index);
            state.form8data = state.form8data.filter((_, i) => i !== index);
        },
        addAllInFrom8:(state,action)=>{
            state.allform8Data = action.payload;
        }
    }
});

export const { setForm8Data,addAllInFrom8, deleteForm8DataByIndex } = formDataReducer.actions;
export default formDataReducer.reducer;
